/* Haye Nii (task 32): story tiles viewer (sections/hn-story-tiles.liquid).
   Tap a round tile = full-screen photos of that collection's products, one per product.
   Tap right side = next photo, left side = back, hold = pause, swipe down = close, swipe sideways = next/previous tile.
   After the last photo the next tile starts by itself; after the last tile the viewer closes.
   Phone Back, Esc and X close it. Seen tiles get a grey ring (remembered on this phone only).
   Nothing loads until a tile is tapped; then only the photo on screen and the next one.
   Task 35: after each product's photo comes one real reel of that product (assets/hayenii-reels.json, read on the first
   tap; "lead" video first, else the first one). The video starts muted (sound button), its bar follows the video
   length, and it loads only when its slide comes up. No reel / list not readable / video fails: photo only.
   Task 37 (owner 2026-10-17, "smooth, luxury"): photo -> video is a clean fade (no zoom: the frame changes size only
   when the new picture is ready); each product's reel is SHUFFLED on every visit (never the same one twice in a row on
   this phone; a video marked "story": 1 in the list is always used = the owner's pick); moving to another circle turns
   like a cube (Instagram); the sound choice is shared with the homepage reels for this visit; a volume-up key turns the
   sound on where the browser passes it on (computers, some Android; iPhone Safari never tells a web page).
   Audit C (2026-10-18, owner picked "option B"): the "Gift finder" circle is a story with questions. Who is it for? ->
   What should it carry? (long lists only) -> "N pieces" -> photo + reel of each piece -> "Next: all our stories" ->
   the normal circles go on. Skip on every question. Lists: sections/hn-gift-finder.liquid (header group, homepage
   only). Opened by the circle, the "Gift finder" menu item and hayenii.com/#gifts (#gifts-mom ...). */
(function () {
  if (window.hnStoryTilesReady) return;
  window.hnStoryTilesReady = true;

  var SEEN_KEY = 'hn_st_seen';
  var TAPPED_KEY = 'hn_st_tapped';
  var LAST_KEY = 'hn_st_last'; // {handle: video key} = the reel shown last time (the next visit shows another one)
  var SOUND_KEY = 'hn_sound'; // '1' = the shopper turned the sound on (this visit; shared with the homepage reels)
  var CUBE_MS = 460;
  var HOLD_MS = 250;
  var TAP_GAP_MS = 350; // taps in the first 350 ms of a new card/photo are ignored (double taps, fast taps: break-it S2)
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // The spin popup stays out of sight on this page once the shopper has opened the videos or the story circles (owner
  // 2026-10-18: it opened on its timer behind the videos and jumped out when they closed). CSS: hayenii-spin-skin.liquid.
  // PopSpin's show() adds its overlay, sets body overflow hidden ONCE (its scroll lock) and then the "open" attribute on
  // <spin-wheel-popup>. Only that one lock is taken off, at that moment, and only for a popup held out of sight; locks
  // from anything else (menu, cart, search, chat) are never touched. Same block in hayenii-reels.js and hn-story-tiles.js.
  var hnQuiet = window.hnQuiet || (window.hnQuiet = (function () {
    var on = false, watched = null, tries = 0;
    function freeIfHeld(p) { // the popup is open but out of sight: take off the scroll lock it just put on
      if (on && p.hasAttribute('open') && document.body.style.overflow === 'hidden') document.body.style.overflow = '';
    }
    function watch() {
      var p = document.querySelector('spin-wheel-popup');
      if (!p) { if (++tries < 60) setTimeout(watch, 1000); return; } // PopSpin not on the page (yet)
      if (watched === p) return;
      watched = p;
      freeIfHeld(p); // it opened at the same moment
      if (window.MutationObserver) new MutationObserver(function () { freeIfHeld(p); }).observe(p, { attributes: true, attributeFilter: ['open'] });
    }
    function start() {
      if (on) return;
      on = true;
      document.documentElement.classList.add('hn-ps-quiet');
      watch();
    }
    return { start: start };
  })());
  // Which copy of a video a phone gets (speed round 2026-10-18; the same block is in hayenii-reels.js and
  // hn-story-tiles.js, the first one loaded is used by both). Shopify keeps 3 copies of every video with the same
  // number: 1080p, 720p and 480p (checked all 201). Computers: as uploaded. Phones: 720p, or 480p when the connection
  // is slow (measured from the videos and pictures this phone has already loaded), so the video never waits.
  var hnVideo = window.hnVideo || (window.hnVideo = (function () {
    var seen = []; // {u: video address, m: Mbps measured} for the last 4 videos
    var low = null; // true = 480p, false = 720p, null = not known yet
    function mbps() {
      if (seen.length) return Math.max.apply(null, seen.map(function (x) { return x.m; })); // 2 load at once: each sees part
      var c = navigator.connection;
      if (c && (c.saveData || /(^|-)(2g|3g)$/.test(c.effectiveType || ''))) return 1;
      try { // from the page's own big downloads (the Shopify CDN allows reading their timing; works on iPhone too)
        var r = [];
        performance.getEntriesByType('resource').forEach(function (e) {
          var ms = e.responseEnd - e.responseStart;
          if (e.transferSize > 60000 && ms > 40) r.push(e.transferSize * 8 / ms / 1000);
        });
        if (r.length > 1) { r.sort(function (a, b) { return a - b; }); return r[Math.floor(r.length / 2)]; }
      } catch (e) { /* no timing */ }
      return (c && c.downlink) || 0; // last: Chrome's own guess (often far too low on a fresh page)
    }
    function pick(url) {
      if (window.innerWidth >= 768 || !url) return url;
      var m = mbps();
      if (m) low = low ? m < 3 : m < 2; // a little room either way, so it does not flip back and forth
      var u = url.replace('.HD-1080p-2.5Mbps-', '.HD-720p-1.6Mbps-').replace('.HD-1080p-3.3Mbps-', '.HD-720p-2.1Mbps-');
      if (low) u = u.replace('.HD-720p-1.6Mbps-', '.SD-480p-0.9Mbps-').replace('.HD-720p-2.1Mbps-', '.SD-480p-1.0Mbps-');
      return u;
    }
    // called on the video's "progress": seconds of video loaded x its bitrate / time since it got its source
    function learn(v) {
      if (!v || !v.hnStart || !v.buffered || !v.buffered.length || !(v.duration > 0) || v.preload !== 'auto') return;
      var u = v.currentSrc || '';
      var secs = (performance.now() - v.hnStart) / 1000;
      var got = v.buffered.end(v.buffered.length - 1);
      var rate = /-(\d+(?:\.\d+)?)Mbps-/.exec(u);
      if (!rate || (secs < 1 && got < v.duration - 0.3)) return; // too early to tell (a whole short video counts)
      var m = (got - (v.hnGot0 || 0)) * parseFloat(rate[1]) / Math.max(secs, 0.25);
      for (var k = 0; k < seen.length; k++) if (seen[k].u === u) { seen[k].m = Math.max(seen[k].m, m); return; }
      seen.push({ u: u, m: m });
      if (seen.length > 4) seen.shift();
    }
    return { pick: pick, learn: learn };
  })());

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function readSeen() {
    try { return JSON.parse(localStorage.getItem(SEEN_KEY) || '[]') || []; } catch (e) { return []; }
  }
  function markSeen(url) {
    try {
      var s = readSeen();
      if (s.indexOf(url) === -1) { s.push(url); localStorage.setItem(SEEN_KEY, JSON.stringify(s.slice(-30))); }
    } catch (e) { /* private mode: no memory, still works */ }
  }

  var ICON_X = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M8 5v14M16 5v14" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>';
  var ICON_L = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var NAME_FAMILY = ['custom-punjabi-name-necklace', 'custom-name-necklace-english', 'custom-hindi-name-necklace', 'custom-arabic-name-necklace',
    'custom-bengali-name-necklace-personalized-bengali-script-jewelry', 'custom-gujarati-name-necklace-personalized-gujarati-script-jewelry'];
  var ICON_SOUND_OFF = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" fill="currentColor"/><path d="M16 9.5l5 5M21 9.5l-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var ICON_SOUND_ON = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" fill="currentColor"/><path d="M15.5 9a4 4 0 010 6M18 6.5a7.5 7.5 0 010 11" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var ICON_R = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function Viewer(root) {
    var dataEl = root.querySelector('[data-hn-st-data]');
    try { this.tiles = JSON.parse(dataEl.textContent); } catch (e) { this.tiles = []; }
    this.root = root;
    this.ms = (parseInt(root.getAttribute('data-seconds'), 10) || 5) * 1000;
    this.links = root.querySelectorAll('[data-hn-st-open]');
    this.el = null;
    this.t = 0; this.i = 0;
    this.pushed = false; this.backPending = false;
    this.paused = false; this.loaded = false; this.elapsed = 0; this.last = 0; this.raf = 0;
    this.from = null;
    this.reelsUrl = root.getAttribute('data-reels') || '';
    this.reels = null; // null = not read yet, false = reading, {handle: reel} = ready
    this.sound = false; // the shopper turned the sound on (kept for the next videos and the homepage reels)
    try { this.sound = sessionStorage.getItem(SOUND_KEY) === '1'; } catch (e) { /* private mode */ }
    var self = this;
    var seen = readSeen();
    this.setupGift();
    // First visit: a calm line under the circles until the shopper has opened one (remembered on this phone)
    this.hint = root.querySelector('[data-hn-st-hint]');
    try { if (this.hint && !localStorage.getItem(TAPPED_KEY)) this.hint.hidden = false; } catch (e) { if (this.hint) this.hint.hidden = false; }
    this.invite();
    this.links.forEach(function (a, n) {
      var tile = self.tiles[n];
      if (tile && tile.gift && !tile.items.length) { var li = a.closest('li'); if (li) li.hidden = true; } // no gift lists: no circle
      if (tile && !tile.gift && seen.indexOf(tile.url) !== -1) a.classList.add('hn-st__tile--seen');
      var early = function () {
        var it = tile && tile.items && tile.items[0];
        if (it && !a.hnEarly && (it.pt || it.s)) { a.hnEarly = true; var im = new Image(); if (it.pt) im.src = it.pt; else { im.sizes = '(min-width: 750px) 480px, 100vw'; if (it.ss) im.srcset = it.ss; im.src = it.s; } }
        self.loadReels();
      };
      a.addEventListener('pointerdown', early, { passive: true });
      a.addEventListener('mouseenter', early, { passive: true });
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return; // new tab: normal link
        if (!tile || !tile.items || !tile.items.length) return; // nothing to show: open the collection
        e.preventDefault();
        self.open(n, a);
      });
    });
  }

  // ---- Gift finder (audit C) ----
  Viewer.prototype.setupGift = function () {
    var gt = -1;
    this.tiles.forEach(function (t, n) { if (t.gift && gt < 0) gt = n; });
    this.gt = gt;
    if (gt < 0) return;
    var el = document.querySelector('[data-hn-gf-data]'), D = null;
    try { D = el ? JSON.parse(el.textContent) : null; } catch (e) { D = null; }
    var P = (D && D.p) || {};
    var groups = ((D && D.g) || []).map(function (g) {
      g.items = (g.i || []).filter(function (h) { return P[h] && P[h].s; });
      return g;
    }).filter(function (g) { return g.items.length; });
    this.gf = groups.length ? { D: D, P: P, g: groups } : null;
    this.tiles[gt].items = this.gf ? [{ q: 'who' }] : [];
    this.tiles[gt].g = -1;
    this.tiles[gt].withReels = true; // the gift story adds its own reels
  };
  Viewer.prototype.gfKinds = function (g) {
    var P = this.gf.P, K = this.gf.D.k || {}, count = {};
    g.items.forEach(function (h) { var k = P[h].k; count[k] = (count[k] || 0) + 1; });
    return ['name', 'photo', 'initial', 'faith'].filter(function (k) { return count[k] && K[k]; }).map(function (k) {
      return { k: k, n: count[k], first: g.items.filter(function (h) { return P[h].k === k; })[0] };
    });
  };
  Viewer.prototype.gfAsks = function (g) { return g.items.length > (this.gf.D.min || 8) && this.gfKinds(g).length > 1; };
  // (Re)build the gift story's slides for list gi (-1 = only the first question) and kind k; askedOnly = stop at the
  // second question
  Viewer.prototype.gfBuild = function (gi, k, askedOnly) {
    var tile = this.tiles[this.gt], gf = this.gf, self = this;
    var g = gf.g[gi];
    tile.g = g ? gi : -1; tile.k = k || '';
    var items = [{ q: 'who' }];
    if (g) {
      if (this.gfAsks(g)) items.push({ q: 'kind' });
      if (!askedOnly) {
        var list = g.items.filter(function (h) { return !tile.k || gf.P[h].k === tile.k; });
        items.push({ q: 'intro', n: list.length });
        var by = this.reels || {};
        list.forEach(function (h) {
          var p = gf.P[h];
          var it = { t: p.t, u: p.u, p: p.p, a: p.a, h: h, b: p.b, s: p.s, ss: p.ss };
          if (p.pt) it.pt = p.pt;
          items.push(it);
          var r = self.reelFor(by, h);
          if (r) items.push({ t: it.t, u: it.u, p: it.p, a: it.a, b: it.b, h: h, vid: r.v, poster: r.p || '', w: r.w || '' });
        });
        items.push({ q: 'end' });
      }
    }
    tile.items = items;
    tile.reeled = !!this.reels; // built with the reel list (false = photos only for now; addReels rebuilds it)
    if (this.bars && this.t === this.gt) this.bars.innerHTML = items.map(function () { return '<span><i></i></span>'; }).join('');
  };
  Viewer.prototype.gfPick = function (gi) {
    var g = this.gf.g[gi];
    if (!g) return;
    this.gfBuild(gi, '', this.gfAsks(g));
    this.show(1);
  };
  Viewer.prototype.gfKind = function (k) {
    this.gfBuild(this.tiles[this.gt].g, k);
    this.show(2);
  };
  Viewer.prototype.gfAgain = function () { this.gfBuild(-1); this.show(0); };
  // Draw a question / note card of the gift story
  Viewer.prototype.gfCard = function (it) {
    // owner 2026-10-18: clean and simple. Both questions = the same round photos; a Back button after the first one; a
    // bold white "Skip" so people see the finder is only a help
    var gf = this.gf, D = gf.D, tile = this.tiles[this.gt], g = gf.g[tile.g];
    var ICON_BACK = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var back = '<button type="button" class="hn-gq__back" data-gq="back">' + ICON_BACK + esc(D.back || 'Back') + '</button>';
    var skip = '<button type="button" class="hn-gq__skip" data-gq="skip">' + esc(D.skip || 'Skip to all stories') + '</button>';
    var choice = function (attrs, on, img, img2, label) {
      return '<button type="button" class="hn-gq__choice' + (on ? ' is-on' : '') + '" ' + attrs + '>' +
        '<span class="hn-gq__ring">' + (img ? '<img src="' + esc(img) + '"' + (img2 ? ' srcset="' + esc(img) + ' 1x, ' + esc(img2) + ' 2x"' : '') + ' alt="" width="80" height="80">' : '') + '</span>' +
        '<span class="hn-gq__label">' + esc(label) + '</span></button>';
    };
    var html = '';
    if (it.q === 'who') {
      html = '<h2 class="hn-gq__title">' + esc(D.h1) + '</h2>' +
        (D.help ? '<p class="hn-gq__help">' + esc(D.help) + '</p>' : '') +
        '<div class="hn-gq__grid">' + gf.g.map(function (gr, n) {
          return choice('data-gq="g" data-n="' + n + '"', tile.g === n, gr.m, gr.m2, gr.l);
        }).join('') + '</div>' + skip;
    } else if (it.q === 'kind') {
      html = back + '<h2 class="hn-gq__title">' + esc(D.h2) + '</h2>' +
        '<p class="hn-gq__for">' + esc(g.l) + '</p>' +
        '<div class="hn-gq__grid">' + this.gfKinds(g).map(function (k) {
          var p = gf.P[k.first];
          return choice('data-gq="k" data-k="' + k.k + '"', tile.k === k.k, p.m, '', D.k[k.k]);
        }).join('') +
        '<button type="button" class="hn-gq__choice hn-gq__choice--all" data-gq="k" data-k="">' +
          '<span class="hn-gq__ring"><span class="hn-gq__all">' + g.items.length + '</span></span>' +
          '<span class="hn-gq__label">' + esc(D.all || 'All') + '</span></button>' +
        '</div>' + skip;
    } else if (it.q === 'intro') {
      html = back + '<h2 class="hn-gq__title hn-gq__title--big">' + esc(g.l) + '</h2>' +
        '<p class="hn-gq__help">' + esc((tile.k && D.k[tile.k] ? D.k[tile.k] + ' · ' : '') + it.n + ' ' + (it.n === 1 ? (D.piece || 'piece') : (D.pieces || 'pieces'))) + '</p>' +
        '<p class="hn-gq__hint">' + esc(D.introHint || 'Tap for the next piece. Swipe left to leave.') + '</p>';
    } else {
      html = '<h2 class="hn-gq__title">' + esc(D.endTitle || 'Next: all our stories') + '</h2>' +
        '<div class="hn-gq__row"><button type="button" class="hn-gq__btn" data-gq="again">' + esc(D.again || 'Start again') + '</button>' +
        '<button type="button" class="hn-gq__btn hn-gq__btn--main" data-gq="next">' + esc(D.next || 'Keep watching') + '</button></div>';
    }
    this.quiz.innerHTML = '<div class="hn-gq hn-gq--' + it.q + '">' + html + '</div>';
    this.quiz.scrollTop = 0;
  };
  // One reel for a piece (the same choice rules as the circles)
  Viewer.prototype.reelFor = function (by, h) {
    var pool = (h && by[h]) || [];
    if (h === 'namelicious-personalized-name-necklace' && !pool.some(function (x) { return x.story; })) {
      NAME_FAMILY.forEach(function (fh) { pool = pool.concat(by[fh] || []); });
    }
    return pickReel(pool, h);
  };
  // Open the gift story (circle, menu item, #gifts link); id = a list's link name (#gifts-mom) to start on that list
  Viewer.prototype.openGift = function (id, from) {
    if (this.gt < 0 || !this.gf) return false;
    if (this.el && !this.el.hidden) this.close(true);
    this.open(this.gt, from || this.links[this.gt]);
    if (id) {
      for (var n = 0; n < this.gf.g.length; n++) if (this.gf.g[n].id === id) { this.gfPick(n); break; }
    }
    return true;
  };

  // Owner 2026-10-17: show that the circles open. When the row comes into view, the gold rings of the circles not seen
  // yet catch the light one after another (3 times, 7 s apart; stops for good after the first tap). Reduce motion: none.
  Viewer.prototype.invite = function () {
    var root = this.root, self = this;
    if (REDUCED || !('IntersectionObserver' in window)) return;
    var runs = 0, timer = 0, visible = false;
    var play = function () {
      clearTimeout(timer);
      if (!visible || runs >= 3 || self.tapped) return;
      runs++;
      root.classList.remove('hn-st--invite');
      void root.offsetWidth;
      root.classList.add('hn-st--invite');
      timer = setTimeout(play, 7000);
    };
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible && !timer) setTimeout(play, 500); else if (!visible) { clearTimeout(timer); timer = 0; }
    }, { threshold: 0.6 }).observe(root.querySelector('.hn-st__row') || root);
  };

  Viewer.prototype.build = function () {
    var self = this;
    var el = document.createElement('div');
    el.className = 'hn-sv';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.hidden = true;
    el.innerHTML =
      '<button type="button" class="hn-sv__side hn-sv__side--prev" data-sv-tile="-1" aria-label="Previous collection">' + ICON_L + '</button>' +
      '<div class="hn-sv__stage">' +
        '<div class="hn-sv__bg" aria-hidden="true"></div>' +
        '<div class="hn-sv__pics" aria-hidden="true"></div>' +
        '<div class="hn-sv__quiz"></div>' +
        '<div class="hn-sv__bars" aria-hidden="true"></div>' +
        '<div class="hn-sv__top">' +
          '<span class="hn-sv__who"><span class="hn-sv__av"></span><b class="hn-sv__name"></b><span class="hn-sv__step"></span></span>' +
          '<button type="button" class="hn-sv__sound" aria-label="Sound on" hidden>' + ICON_SOUND_OFF + '</button>' +
          '<button type="button" class="hn-sv__pause" aria-label="Pause">' + ICON_PAUSE + '</button>' +
          '<button type="button" class="hn-sv__close" aria-label="Close">' + ICON_X + '</button>' +
        '</div>' +
        '<div class="hn-sv__foot">' +
          '<p class="hn-sv__by" hidden></p>' +
          '<p class="hn-sv__title"></p>' +
          '<p class="hn-sv__price"></p>' +
          '<a class="hn-sv__shop" href="#">Shop</a>' +
          '<a class="hn-sv__all" href="#"></a>' +
        '</div>' +
        '<button type="button" class="hn-sv__nav hn-sv__nav--prev" data-sv-step="-1" aria-label="Previous photo"></button>' +
        '<button type="button" class="hn-sv__nav hn-sv__nav--next" data-sv-step="1" aria-label="Next photo"></button>' +
        '<p class="hn-sv__live visually-hidden" aria-live="polite"></p>' +
      '</div>' +
      '<button type="button" class="hn-sv__side hn-sv__side--next" data-sv-tile="1" aria-label="Next collection">' + ICON_R + '</button>';
    document.body.appendChild(el);
    this.el = el;
    this.stage = el.querySelector('.hn-sv__stage');
    this.pics = el.querySelector('.hn-sv__pics');
    this.bg = el.querySelector('.hn-sv__bg');
    this.bars = el.querySelector('.hn-sv__bars');
    this.quiz = el.querySelector('.hn-sv__quiz');
    this.quiz.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gq]');
      if (!b) return;
      if (performance.now() - self.shownAt < TAP_GAP_MS) return; // 2nd tap of a double tap: not an answer on the new card
      var a = b.getAttribute('data-gq');
      if (a === 'g') self.gfPick(parseInt(b.getAttribute('data-n'), 10));
      else if (a === 'k') self.gfKind(b.getAttribute('data-k') || '');
      else if (a === 'again') self.gfAgain();
      else if (a === 'back') self.step(-1);
      else if (a === 'skip' || a === 'next') self.tile(self.t + 1, true);
    });

    el.querySelector('.hn-sv__close').addEventListener('click', function () { self.close(false); });
    this.pauseBtn = el.querySelector('.hn-sv__pause');
    this.pauseBtn.addEventListener('click', function () { self.setStopped(!self.stopped); });
    this.soundBtn = el.querySelector('.hn-sv__sound');
    this.soundBtn.addEventListener('click', function () { self.setSound(!self.sound); });
    el.querySelectorAll('[data-sv-tile]').forEach(function (b) {
      b.addEventListener('click', function () { self.tile(self.t + parseInt(b.getAttribute('data-sv-tile'), 10), true); });
    });
    // Keyboard / screen reader buttons (hidden until focused; taps use the photo area below)
    el.querySelectorAll('[data-sv-step]').forEach(function (b) {
      b.addEventListener('click', function () { self.step(parseInt(b.getAttribute('data-sv-step'), 10)); });
    });

    // Tap, hold and swipe on the photo area
    var start = null;
    this.stage.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      if (e.target.closest('a, button')) {
        // finger on Shop / See all / a button: freeze the timer so the photo cannot change under the finger
        self.linkHold = true; self.hold(true, true);
        return;
      }
      start = { x: e.clientX, y: e.clientY, t: Date.now(), id: e.pointerId, held: false };
      start.timer = setTimeout(function () { if (start) { start.held = true; self.hold(true); } }, HOLD_MS);
    });
    var end = function (e, cancelled) {
      if (self.linkHold) { self.linkHold = false; setTimeout(function () { self.hold(false); }, 400); }
      if (!start || e.pointerId !== start.id) return;
      clearTimeout(start.timer);
      var s = start; start = null;
      var dx = e.clientX - s.x, dy = e.clientY - s.y;
      if (s.held) self.hold(false);
      if (cancelled) return;
      if (dy > 70 && Math.abs(dy) > Math.abs(dx)) { self.close(false); return; }
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { self.tile(self.t + (dx < 0 ? 1 : -1), true); return; }
      if (s.held || Math.abs(dx) > 10 || Math.abs(dy) > 10) { return; }
      if (self.asking) return; // a question card: only its buttons (and swipes) move on, never a stray tap
      if (performance.now() - self.shownAt < TAP_GAP_MS) return; // fast taps: no skipping photos the shopper never saw
      var r = self.stage.getBoundingClientRect();
      self.step(e.clientX - r.left < r.width * 0.25 ? -1 : 1);
    };
    this.stage.addEventListener('pointerup', function (e) { end(e, false); });
    this.stage.addEventListener('pointercancel', function (e) { end(e, true); });
    this.stage.addEventListener('contextmenu', function (e) { if (!e.target.closest('a')) e.preventDefault(); });
    // The page under the viewer must not scroll (iPhone ignores overflow:hidden on some pages)
    el.addEventListener('touchmove', function (e) {
      // a question card taller than a small phone scrolls
      if (e.target.closest && e.target.closest('.hn-sv__quiz') && self.quiz.scrollHeight > self.quiz.clientHeight + 2) return;
      e.preventDefault();
    }, { passive: false });

    // Computer: a click on the dark area around the story closes it
    el.addEventListener('click', function (e) { if (e.target === el) self.close(false); });

    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.close(false); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); self.step(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); self.step(-1); }
      else if (e.key === 'Tab') self.trap(e);
      else if (e.key === 'm' || e.key === 'M') self.setSound(!self.sound);
    });
    // a volume-up key (keyboards, some Android browsers) = sound on, like Instagram; iPhone never passes it to a page
    document.addEventListener('keydown', function (e) {
      if (!self.el.hidden && (e.key === 'AudioVolumeUp' || e.key === 'VolumeUp') && !self.sound) self.setSound(true);
    });
    document.addEventListener('visibilitychange', function () {
      if (self.el.hidden) return;
      if (document.hidden) self.hold(true); else self.hold(false);
    });
    window.addEventListener('popstate', function () {
      if (self.backPending) { self.backPending = false; return; }
      if (self.el && !self.el.hidden) self.close(true);
    });
    // No close on pagehide: after Shop -> product -> Back the page may come back from the browser's memory with the
    // story still open, which matches the history step (Back then closes it).
  };

  Viewer.prototype.trap = function (e) {
    var f = Array.prototype.filter.call(this.el.querySelectorAll('a[href], button'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  // restore = {i}: reopen after a page reload on the story's own history step (no new step, paused)
  Viewer.prototype.open = function (n, from, restore) {
    if (!this.el) this.build();
    this.from = from || null;
    this.el.hidden = false;
    this.lock(true);
    if (restore) this.pushed = true;
    else if (!this.pushed) {
      try { history.pushState({ hnStory: true, t: n, i: 0, c: this.custom ? 1 : 0 }, ''); this.pushed = true; } catch (e) { this.pushed = false; }
    }
    this.tapped = true;
    this.root.classList.remove('hn-st--invite');
    if (this.hint) { this.hint.hidden = true; try { localStorage.setItem(TAPPED_KEY, '1'); } catch (e) { /* private mode */ } }
    this.setStopped(restore ? true : REDUCED);
    // owner 2026-10-17: the circle that was tapped shows ALL its pieces; the next circles in the same viewing skip
    // the pieces already shown (e.g. the Kara is in Sikh and in Bracelets: once is enough)
    this.excl = {}; this.seenH = {}; this.first = n;
    if (this.tiles[n] && this.tiles[n].gift && this.gf) {
      var rg = restore && restore.gf;
      if (rg && this.gf.g[rg.g]) this.gfBuild(rg.g, rg.k || '', !!rg.a); else this.gfBuild(-1);
      if (rg && (rg.q || rg.h)) {
        this.tiles[n].items.forEach(function (it, k) { if (rg.q ? it.q === rg.q : (!it.vid && it.h === rg.h)) restore.i = k; });
      }
    }
    this.tile(n, false, restore ? restore.i : 0);
    this.loadReels();
    this.el.querySelector('.hn-sv__close').focus({ preventScroll: true });
  };

  // iPhone ignores overflow:hidden for touch scrolling: pin the page in place and put it back on close
  Viewer.prototype.lock = function (on) {
    var b = document.body;
    if (on) {
      this.scrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('hn-sv-open');
      hnQuiet.start();
      b.style.position = 'fixed'; b.style.top = -this.scrollY + 'px'; b.style.left = '0'; b.style.right = '0';
    } else {
      document.documentElement.classList.remove('hn-sv-open');
      b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = '';
      window.scrollTo(0, this.scrollY || 0);
    }
  };

  // Pause button (and "reduce motion" phones): photos stay until tapped
  Viewer.prototype.setStopped = function (on) {
    this.stopped = on;
    this.pauseBtn.innerHTML = on ? ICON_PLAY : ICON_PAUSE;
    this.pauseBtn.setAttribute('aria-label', on ? 'Play' : 'Pause');
    if (!on) { this.last = performance.now(); this.tick(); }
    this.playVideo();
  };

  // Read the reel list once (the same file as the homepage reels) and add one reel after each product's photo
  Viewer.prototype.loadReels = function () {
    var self = this;
    if (this.reels !== null || !this.reelsUrl || !window.fetch) return;
    this.reels = false;
    fetch(this.reelsUrl).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }).then(function (list) {
      var by = {};
      (Array.isArray(list) ? list : []).forEach(function (r) {
        if (!r || typeof r.h !== 'string' || typeof r.v !== 'string' || !/^https:\/\/cdn\.shopify\.com\//.test(r.v)) return;
        (by[r.h] = by[r.h] || []).push(r);
      });
      self.reels = by;
      self.addReels();
    }).catch(function () { self.reels = {}; });
  };

  // One reel per product for this visit: the owner's pick ("story": 1) if there is one, else a random one that is not
  // the one this phone saw last time
  function pickReel(pool, h) {
    if (!pool || !pool.length) return null;
    for (var k = 0; k < pool.length; k++) if (pool[k].story) return pool[k];
    var last = {};
    try { last = JSON.parse(localStorage.getItem(LAST_KEY) || '{}') || {}; } catch (e) { last = {}; }
    var choice = pool.length > 1 ? pool.filter(function (r) { return (r.k || r.v) !== last[h]; }) : pool;
    if (!choice.length) choice = pool;
    var r = choice[Math.floor(Math.random() * choice.length)];
    try { last[h] = r.k || r.v; localStorage.setItem(LAST_KEY, JSON.stringify(last)); } catch (e) { /* private mode */ }
    return r;
  }

  Viewer.prototype.addReels = function () {
    var by = this.reels || {}, self = this;
    var cur = this.items(this.t)[this.i];
    this.tiles.forEach(function (tile) {
      if (!tile.items || tile.withReels) return;
      var out = [];
      tile.items.forEach(function (it) {
        out.push(it);
        // the Any-language name necklace is the same necklace as the language listings (owner): any of their reels
        var r = self.reelFor(by, it.h);
        if (r) out.push({ t: it.t, u: it.u, p: it.p, a: it.a, b: it.b, h: it.h, vid: r.v, poster: r.p || '', w: r.w || '' });
      });
      tile.items = out;
      tile.withReels = true;
    });
    // the gift story was built before the reels were read: rebuild it with reels, staying on the same card / piece
    var gtile = this.gf && this.tiles[this.gt];
    if (gtile && !gtile.reeled && gtile.g >= 0 && gtile.items.length > 2) {
      var onGift = this.el && !this.el.hidden && this.t === this.gt;
      var was = onGift ? gtile.items[this.i] : null;
      this.gfBuild(gtile.g, gtile.k);
      if (onGift && was) {
        var ni = 0;
        gtile.items.forEach(function (it, n) { if (it.q ? it.q === was.q : (!it.vid && it.h === was.h)) ni = n; });
        if (was.vid) ni = Math.min(ni + 1, gtile.items.length - 1);
        this.i = ni;
        var bi = this.bars.querySelectorAll('i');
        bi.forEach(function (b, n) { b.style.transform = 'scaleX(' + (n < ni ? 1 : 0) + ')'; });
        if (this.pushed) { try { history.replaceState(this.histState(ni), ''); } catch (e) { /* ignore */ } }
        if (!this.asking) this.tick(); // the running bar is the new one
      }
    }
    if (!this.el || this.el.hidden || (this.tiles[this.t] && this.tiles[this.t].gift)) return; // the gift story keeps its own bars
    // the story on screen gets its new bars; the photo on screen stays where it is
    var shown = this.items(this.t);
    var i = Math.max(0, shown.indexOf(cur));
    this.i = i;
    this.bars.innerHTML = shown.map(function () { return '<span><i></i></span>'; }).join('');
    this.bars.querySelectorAll('i').forEach(function (b, n) { b.style.transform = 'scaleX(' + (n < i ? 1 : 0) + ')'; });
    this.el.querySelector('.hn-sv__step').textContent = (i + 1) + ' of ' + shown.length;
    if (this.pushed) { try { history.replaceState(this.histState(i), ''); } catch (e) { /* ignore */ } }
    this.tick();
    if (this.loaded) this.preload(); // the list came after the photo: its reel (now next) loads ahead too
  };

  Viewer.prototype.setSound = function (on) {
    this.sound = on;
    try { sessionStorage.setItem(SOUND_KEY, on ? '1' : '0'); } catch (e) { /* private mode */ }
    this.soundBtn.classList.remove('hn-sv__sound--hint');
    this.soundBtn.innerHTML = on ? ICON_SOUND_ON : ICON_SOUND_OFF;
    this.soundBtn.setAttribute('aria-label', on ? 'Sound off' : 'Sound on');
    if (this.video) this.video.muted = !on;
  };

  // The video on screen plays only when nothing holds it (pause button, finger hold, hidden tab)
  Viewer.prototype.playVideo = function () {
    var v = this.video;
    if (!v || !this.loaded) return;
    if (this.stopped || this.paused || this.el.hidden) { v.pause(); return; }
    var self = this;
    var pr = v.play();
    if (pr && pr.catch) pr.catch(function () {
      if (self.video !== v) return;
      if (!v.muted) { self.setSound(false); v.play().catch(function () { /* stays on the poster */ }); return; } // phone refused sound: play muted
      self.videoFailed = true; self.last = performance.now(); self.tick(); // could not play: the timer moves on
    });
  };

  Viewer.prototype.stopVideos = function () {
    this.pics.querySelectorAll('video').forEach(function (v) { v.pause(); v.removeAttribute('src'); v.load(); });
    this.video = null;
    this.dropAhead();
  };

  // Speed round (2026-10-18): the reel after a photo starts loading while the photo is on screen (it waits, without
  // sound, on its first picture), so it shows at once. Before, it only started loading when its slide came up, as the
  // big 1080p file. Phones now get the 720p copy (480p on a slow connection), like the homepage reels.
  Viewer.prototype.makeVideo = function (it) {
    var v = document.createElement('video');
    v.className = 'hn-sv__img hn-sv__vid';
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.setAttribute('disablepictureinpicture', '');
    v.setAttribute('aria-hidden', 'true');
    v.preload = 'auto';
    if (it.poster) v.poster = it.poster;
    var url = hnVideo.pick(it.vid);
    if (url !== it.vid) v.addEventListener('error', function again() { v.removeEventListener('error', again); v.src = it.vid; });
    v.addEventListener('progress', function () { hnVideo.learn(v); });
    v.hnStart = performance.now();
    v.src = url;
    return v;
  };
  Viewer.prototype.dropAhead = function () {
    var a = this.ahead;
    this.ahead = null;
    if (!a) return;
    try { a.v.pause(); a.v.removeAttribute('src'); a.v.load(); } catch (e) { /* gone */ }
    if (a.v.parentNode) a.v.parentNode.removeChild(a.v);
  };
  Viewer.prototype.loadAhead = function (it) {
    if (!this.el || this.el.hidden) return; // closed: load nothing more
    if (this.ahead && this.ahead.it === it) return;
    this.dropAhead();
    var v = this.makeVideo(it);
    v.classList.add('hn-sv__ahead');
    this.el.appendChild(v); // out of sight (CSS), but in the page: iPhone loads only videos that are in the page
    this.ahead = { it: it, v: v };
    var self = this;
    // iPhone round (owner 2026-10-18: a pause on a real iPhone): iPhone Safari loads (almost) nothing for a video that is
    // not playing. So it PLAYS without sound, out of sight and in slow motion (it moves only a few tenths of a second),
    // until its first 3 s are loaded (or 8 s have passed), then it waits for its slide.
    var t0 = performance.now();
    var mine = function () { return self.ahead && self.ahead.v === v; };
    var loaded = function () {
      try { var b = v.buffered; for (var k = 0; k < b.length; k++) if (b.start(k) <= 0.3) return b.end(k); } catch (e) { /* none */ }
      return 0;
    };
    var timer = setInterval(function () {
      if (!mine()) { clearInterval(timer); return; } // its slide came up (it plays there) or it was dropped
      if (loaded() < Math.min(3, (v.duration || 99) - 0.3) && performance.now() - t0 < 8000 && v.currentTime < 1.2) return;
      clearInterval(timer);
      v.pause();
      v.playbackRate = 1;
      if (v.currentTime > 1) { try { v.currentTime = 0; } catch (e) { /* not ready */ } } // slow motion not possible here
    }, 250);
    try { v.playbackRate = 0.1; } catch (e) { /* normal speed */ }
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* not allowed (Low Power Mode): it still loads what it can */ });
  };

  Viewer.prototype.close = function (fromBack) {
    if (!this.el || this.el.hidden) return;
    cancelAnimationFrame(this.raf);
    this.endCube();
    this.el.hidden = true;
    this.token = {}; // late photo/video callbacks of the closed story stop here (no warm-up download after closing)
    this.stopVideos();
    this.pics.innerHTML = '';
    this.lock(false);
    if (this.pushed && !fromBack && history.state && history.state.hnStory) { this.backPending = true; history.back(); }
    this.pushed = false;
    if (this.custom) { this.tiles = this.saved.tiles; this.links = this.saved.links; this.custom = false; this.saved = null; }
    if (this.from) this.from.focus({ preventScroll: true });
  };

  // Audit C: play a list of pieces (gift finder picks) as one story; list = {title, url, items: [{t,u,p,a,h,b,s,ss,pt}]}
  Viewer.prototype.histState = function (i) {
    var st = { hnStory: true, t: this.t, i: i, c: this.custom ? 1 : 0 };
    var tile = this.tiles[this.t];
    if (tile && tile.gift && tile.g >= 0) {
      var cur = tile.items[i] || {};
      // the piece itself (not only its number): after a reload the reels may not be read yet, so numbers can shift
      st.gf = { g: tile.g, k: tile.k || '', a: tile.items.length <= 2 ? 1 : 0, q: cur.q || '', h: cur.h || '' };
    }
    return st;
  };

  Viewer.prototype.playList = function (list, from) {
    if (!list || !list.items || !list.items.length || (this.el && !this.el.hidden)) return false;
    this.saved = { tiles: this.tiles, links: this.links };
    this.tiles = [{ label: list.title, title: list.title, url: list.url || '', count: list.items.length, items: list.items.slice(), custom: true }];
    this.links = [];
    this.custom = true;
    this.open(0, from);
    if (this.reels) this.addReels(); // reels already read: add them now (else loadReels adds them when ready)
    return true;
  };

  // The pieces tile n shows in this viewing (see open): fixed the first time the tile comes up, so Back shows the same
  Viewer.prototype.items = function (n) {
    var tile = this.tiles[n];
    if (!tile || !tile.items) return [];
    var ex = this.excl && this.excl[n];
    return ex ? tile.items.filter(function (it) { return !ex[it.h]; }) : tile.items;
  };
  Viewer.prototype.prep = function (n) {
    if (!this.excl || this.excl[n]) return;
    var ex = {};
    if (n !== this.first && !(this.tiles[n] && this.tiles[n].gift)) for (var h in this.seenH) ex[h] = true;
    this.excl[n] = ex;
  };

  // Go to tile n (skipping tiles with nothing (new) to show). Past the last tile = close.
  Viewer.prototype.tile = function (n, user, startAt) {
    var self = this;
    var dir = n < this.t ? -1 : 1;
    var has = function (k) { self.prep(k); return self.items(k).length > 0; };
    while (n >= 0 && n < this.tiles.length && !has(n)) n += dir;
    if (n < 0) n = this.t; // already at the first tile: stay
    if (n >= this.tiles.length) { this.close(false); return; }
    var tile = this.tiles[n];
    var items = this.items(n);
    if (this.seenH) items.forEach(function (it) { self.seenH[it.h] = true; });
    // another circle: the old story turns away like a cube side and the new one turns in (Instagram); the new story
    // starts on a clean frame (never the old photo under the new name)
    if (user && n !== this.t && this.el && !this.el.hidden) {
      this.cube(n > this.t ? 1 : -1);
      this.stopVideos();
      this.pics.innerHTML = '';
    }
    this.t = n;
    var full = tile.title || tile.label; // circle shows the short word, the viewer the full collection name
    this.el.setAttribute('aria-label', full);
    this.el.querySelector('.hn-sv__name').textContent = full;
    var av = tile.gift ? { b: this.gf.g[0].m } : items[0];
    this.el.querySelector('.hn-sv__av').innerHTML = '<img src="' + esc(av.b) + '" alt="" width="32" height="32">';
    var all = this.el.querySelector('.hn-sv__all');
    all.style.display = tile.url ? '' : 'none';
    all.href = tile.url || '#';
    all.textContent = 'See all ' + tile.count;
    all.setAttribute('aria-label', 'See all ' + tile.count + ' in ' + full);
    this.bars.innerHTML = items.map(function () { return '<span><i></i></span>'; }).join('');
    this.el.querySelector('[data-sv-tile="-1"]').disabled = n === 0;
    if (this.links[n] && !tile.gift) this.links[n].classList.add('hn-st__tile--seen');
    if (!this.custom && !tile.gift) markSeen(tile.url);
    var last = items.length - 1;
    this.show(startAt === 'last' ? last : Math.max(0, Math.min(parseInt(startAt, 10) || 0, last)));
  };

  Viewer.prototype.step = function (d) {
    var i = this.i + d;
    if (i < 0) {
      if (this.t > 0) { this.tile(this.t - 1, true, 'last'); return; } // like Instagram: the previous tile's last photo
      i = 0;
    }
    if (i >= this.items(this.t).length) { this.tile(this.t + 1, true); return; }
    this.show(i);
  };

  Viewer.prototype.show = function (i) {
    var self = this;
    var tile = this.tiles[this.t];
    var list = this.items(this.t);
    var it = list[i];
    this.i = i;
    this.shownAt = performance.now();
    this.elapsed = 0;
    this.loaded = false;
    this.paused = false;
    this.el.classList.remove('hn-sv--hold');
    cancelAnimationFrame(this.raf);

    // bars: earlier = full, this one = running, later = empty
    var bars = this.bars.querySelectorAll('i');
    bars.forEach(function (b, n) { b.style.transform = 'scaleX(' + (n < i ? 1 : 0) + ')'; });

    this.asking = false;
    this.stage.classList.toggle('hn-sv--quiz', !!it.q);
    if (it.q) {
      // a gift-finder card: no photo; the questions wait for a tap, the two note cards move on with the timer
      var kb = this.quiz.contains(document.activeElement) || document.activeElement === document.body; // keyboard on a card
      this.stopVideos();
      this.pics.innerHTML = '';
      this.stage.classList.remove('hn-sv--portrait');
      this.bg.style.backgroundImage = 'none';
      this.soundBtn.hidden = true;
      this.el.querySelector('.hn-sv__step').textContent = '';
      this.gfCard(it);
      this.asking = it.q === 'who' || it.q === 'kind';
      this.el.classList.toggle('hn-sv--ask', this.asking);
      if (kb) { var fb = this.quiz.querySelector('button'); if (fb) fb.focus({ preventScroll: true }); }
      var head = this.quiz.querySelector('.hn-gq__title');
      this.el.querySelector('.hn-sv__live').textContent = head ? head.textContent : '';
      if (this.pushed) { try { history.replaceState(this.histState(i), ''); } catch (e) { /* ignore */ } }
      this.video = null;
      this.token = {};
      this.loaded = true;
      this.last = performance.now();
      if (!this.asking) this.tick();
      return;
    }
    this.el.classList.remove('hn-sv--ask');
    this.quiz.innerHTML = '';
    this.el.querySelector('.hn-sv__step').textContent = tile.gift ? '' : (i + 1) + ' of ' + list.length;
    this.el.querySelector('.hn-sv__title').textContent = it.t;
    var by = this.el.querySelector('.hn-sv__by');
    var credit = it.vid && /^@/.test(it.w || ''); // creators are credited; our own videos need no line
    by.textContent = credit ? 'Video: ' + it.w : '';
    by.hidden = !credit;
    this.soundBtn.hidden = !it.vid;
    this.el.querySelector('.hn-sv__price').textContent = it.p;
    var shop = this.el.querySelector('.hn-sv__shop');
    shop.href = it.u;
    shop.setAttribute('aria-label', 'Shop the ' + it.t);
    this.el.querySelector('.hn-sv__live').textContent = (tile.title || tile.label) + ', ' + (i + 1) + ' of ' + list.length + ': ' + it.t + (it.vid ? ', video' : '');
    this.bg.style.backgroundImage = 'url("' + it.b.replace(/"/g, '%22') + '")';
    // remember where we are on the story's history step (reload / Back from a product reopens here)
    if (this.pushed) { try { history.replaceState(this.histState(i), ''); } catch (e) { /* ignore */ } }
    // a portrait story photo (1080 x 1920) or a reel fills the whole screen; otherwise the square product photo.
    // Task 37: the frame changes size only when the new picture is ready, so the old one never zooms or stretches
    var tall = !!(it.pt || it.vid);
    var stage = this.stage;
    var frame = function () { stage.classList.toggle('hn-sv--portrait', tall); };
    if (!this.pics.children.length) frame();
    this.video = null;
    this.videoFailed = false;
    var token = {};
    this.token = token;

    if (it.vid) {
      // A reel: the one loaded ahead (while the photo before it was on screen), else it loads now; plays muted unless
      // the shopper turned the sound on
      var v, warm = false;
      if (this.ahead && this.ahead.it === it) {
        warm = true;
        v = this.ahead.v; this.ahead = null; v.pause(); v.classList.remove('hn-sv__ahead');
        v.playbackRate = 1;
        try { if (v.currentTime > 1) v.currentTime = 0; } catch (e) { /* not ready */ } // (only if slow motion was not possible)
      }
      else { this.dropAhead(); v = this.makeVideo(it); }
      v.muted = !this.sound;
      var vready = function () {
        if (self.token !== token || self.loaded) return;
        Array.prototype.slice.call(self.pics.children).forEach(function (old) { if (old !== v) { if (old.pause) old.pause(); old.remove(); } });
        frame();
        v.classList.add('is-in');
        v.muted = !self.sound; // (a kicked video started without sound)
        self.video = v;
        self.loaded = true;
        self.last = performance.now();
        self.playVideo();
        self.tick();
        self.preload();
        self.soundHint();
      };
      v.addEventListener('loadeddata', vready);
      v.addEventListener('canplay', vready); // also after a jump back to the start (loadeddata comes only once)
      v.addEventListener('ended', function () { if (self.token === token && !self.stopped) self.step(1); });
      v.addEventListener('error', function () { if (self.token !== token) return; self.videoFailed = true; vready(); });
      // a very slow phone: after 8 s move on with the timer (the poster stays)
      setTimeout(function () { if (self.token === token && !self.loaded) { self.videoFailed = true; vready(); } }, 8000);
      this.pics.appendChild(v);
      if (v.readyState >= 2) vready(); // loaded ahead: its first picture is already there
      else if (!warm) {
        // not warmed ahead (going BACK to a reel, or a jump): iPhone Safari loads nothing for a paused new video, so it
        // showed a blurred screen for 8 s (iPhone audit 2026-10-19). Start it now without sound; vready shows it.
        v.muted = true;
        var kick = v.play();
        if (kick && kick.catch) kick.catch(function () { /* not allowed: the 8 s timer moves on, as before */ });
      }
      return;
    }

    // New photo on top; the old one stays until the new one is ready (no white flash)
    var img = new Image();
    img.className = 'hn-sv__img';
    img.alt = it.a || it.t;
    img.decoding = 'async';
    if (it.pt) {
      img.src = it.pt;
    } else {
      img.sizes = '(min-width: 750px) 480px, 100vw';
      img.srcset = it.ss;
      img.src = it.s;
    }
    var ready = function () {
      if (self.token !== token) return;
      Array.prototype.slice.call(self.pics.children).forEach(function (old) { if (old !== img) { if (old.pause) old.pause(); old.remove(); } });
      frame();
      img.classList.add('is-in');
      self.loaded = true;
      self.last = performance.now();
      self.tick();
      self.preload();
    };
    img.onload = ready;
    img.onerror = ready; // a broken photo still moves on
    this.pics.appendChild(img);
    if (img.complete && img.naturalWidth) ready();
  };

  // First muted reel of the visit: the sound button glows twice, so people find it (no words over the video)
  Viewer.prototype.soundHint = function () {
    if (this.sound || this.hinted || REDUCED) return;
    this.hinted = true;
    try { if (sessionStorage.getItem('hn_sound_hint')) return; sessionStorage.setItem('hn_sound_hint', '1'); } catch (e) { /* private mode */ }
    var b = this.soundBtn;
    b.classList.remove('hn-sv__sound--hint');
    void b.offsetWidth;
    b.classList.add('hn-sv__sound--hint');
  };

  // The cube turn between two circles. A still copy of the old story (videos drawn as their current picture) turns away
  // around the cube's middle while the real story turns in. Reduce motion: a short fade instead.
  Viewer.prototype.cube = function (dir) {
    this.endCube();
    var stage = this.stage;
    var r = stage.getBoundingClientRect(), box = this.el.getBoundingClientRect();
    if (!r.width || !stage.animate) return;
    var ghost = stage.cloneNode(true);
    var real = stage.querySelectorAll('video');
    ghost.querySelectorAll('video').forEach(function (v, k) {
      v.removeAttribute('src'); // the copy must never load the video again
      var c = document.createElement('canvas');
      c.className = v.className;
      try {
        var src = real[k];
        if (src && src.videoWidth) { c.width = src.videoWidth; c.height = src.videoHeight; c.getContext('2d').drawImage(src, 0, 0); }
      } catch (e) { /* the picture stays dark */ }
      v.parentNode.replaceChild(c, v);
    });
    ghost.classList.add('hn-sv__ghost');
    ghost.setAttribute('aria-hidden', 'true');
    ghost.style.left = (r.left - box.left) + 'px';
    ghost.style.top = (r.top - box.top) + 'px';
    ghost.style.width = r.width + 'px';
    ghost.style.height = r.height + 'px';
    this.el.appendChild(ghost);
    this.ghost = ghost;
    var self = this;
    var done = function () { if (self.ghost === ghost) self.endCube(); };
    var timing = { duration: REDUCED ? 180 : CUBE_MS, easing: 'cubic-bezier(.32,.08,.24,1)', fill: 'both' };
    var anims;
    if (REDUCED) {
      anims = [ghost.animate([{ opacity: 1 }, { opacity: 0 }], timing)];
    } else {
      var origin = '50% 50% ' + (-r.width / 2) + 'px';
      ghost.style.transformOrigin = origin;
      stage.style.transformOrigin = origin;
      anims = [
        ghost.animate([{ transform: 'rotateY(0deg)', opacity: 1 }, { transform: 'rotateY(' + (-90 * dir) + 'deg)', opacity: 0.35 }], timing),
        stage.animate([{ transform: 'rotateY(' + (90 * dir) + 'deg)' }, { transform: 'rotateY(0deg)' }], timing)
      ];
    }
    this.cubeAnims = anims;
    anims[0].onfinish = done;
    this.cubeTimer = setTimeout(done, timing.duration + 300); // safety: never leave the copy on screen
  };

  Viewer.prototype.endCube = function () {
    clearTimeout(this.cubeTimer);
    (this.cubeAnims || []).forEach(function (a) { try { a.cancel(); } catch (e) { /* done */ } });
    this.cubeAnims = null;
    if (this.ghost) { this.ghost.remove(); this.ghost = null; }
    if (this.stage) this.stage.style.transformOrigin = '';
  };

  Viewer.prototype.preload = function () {
    var nx = this.items(this.t)[this.i + 1];
    if (!nx) { var nt = this.tiles[this.t + 1]; nx = nt && nt.items && nt.items[0]; }
    if (!nx || nx.q) return;
    var p = new Image();
    if (nx.vid) { this.loadAhead(nx); return; } // the next reel loads now, while this photo is on screen
    if (nx.pt) { p.src = nx.pt; return; }
    p.sizes = '(min-width: 750px) 480px, 100vw';
    p.srcset = nx.ss;
    p.src = nx.s;
  };

  Viewer.prototype.hold = function (on, keepUi) {
    if (!this.el || this.el.hidden) return;
    this.paused = on;
    this.el.classList.toggle('hn-sv--hold', on && !keepUi);
    if (!on) { this.last = performance.now(); this.tick(); }
    this.playVideo();
  };

  Viewer.prototype.tick = function () {
    var self = this;
    cancelAnimationFrame(this.raf);
    var bar = this.bars.querySelectorAll('i')[this.i];
    var loop = function (now) {
      if (self.el.hidden || self.paused || self.stopped || !self.loaded || self.asking) return;
      var v = self.video;
      if (v && !self.videoFailed) {
        // a reel: the bar follows the video; "ended" moves on
        if (v.duration > 0 && isFinite(v.duration) && bar) bar.style.transform = 'scaleX(' + Math.min(v.currentTime / v.duration, 1) + ')';
        self.raf = requestAnimationFrame(loop);
        return;
      }
      self.elapsed += now - self.last;
      self.last = now;
      var f = Math.min(self.elapsed / self.ms, 1);
      if (bar) bar.style.transform = 'scaleX(' + f + ')';
      if (f >= 1) { self.step(1); return; }
      self.raf = requestAnimationFrame(loop);
    };
    this.raf = requestAnimationFrame(function (now) { self.last = now; loop(now); });
  };

  function init() {
    document.querySelectorAll('[data-hn-st]').forEach(function (root, k) {
      if (root.hnStory) return;
      root.hnStory = new Viewer(root);
      // The page was reloaded (or rebuilt after Back) on the story's history step: reopen it there, paused,
      // so that one Back press closes it (never a Back press that seems to do nothing)
      var st = history.state;
      if (k === 0 && st && st.hnStory && typeof st.t === 'number' && !st.c) {
        var v = root.hnStory;
        if (v.tiles[st.t] && v.tiles[st.t].items && v.tiles[st.t].items.length) v.open(st.t, v.links[st.t], { i: st.i || 0, gf: st.gf });
        else { try { history.replaceState(null, ''); } catch (e) { /* ignore */ } }
      } else if (k === 0 && st && st.hnStory && st.c) {
        // reloaded on a gift-finder story (Shop -> product -> Back): step back to the gift finder's list
        try { history.back(); } catch (e) { /* ignore */ }
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Gift finder: the menu item (any [data-hn-gf-open] link) and the address hayenii.com/#gifts, #gifts-mom ...
  function giftViewer() {
    var root = document.querySelector('[data-hn-st]');
    if (root && !root.hnStory) init();
    var v = root && root.hnStory;
    return v && v.gt >= 0 && v.gf ? v : null;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-hn-gf-open]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
    var v = giftViewer();
    if (!v) return; // not on the homepage: the link goes there (/#gifts)
    e.preventDefault();
    // the phone menu closes at once (its slide-out animation stalls under the full-screen story)
    var det = document.querySelector('#Details-menu-drawer-container[open]');
    if (det) {
      var hd = det.closest('header-drawer'), sum = det.querySelector('summary');
      det.classList.remove('menu-opening');
      det.querySelectorAll('details').forEach(function (d) { d.removeAttribute('open'); d.classList.remove('menu-opening'); });
      det.querySelectorAll('.submenu-open').forEach(function (x) { x.classList.remove('submenu-open'); });
      det.removeAttribute('open');
      document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop', 'overflow-hidden-mobile');
      if (hd && hd.header) hd.header.classList.remove('menu-open');
      if (sum) sum.setAttribute('aria-expanded', 'false');
      if (typeof window.removeTrapFocus === 'function') { try { window.removeTrapFocus(); } catch (err) { /* ignore */ } }
      a = sum || a; // focus comes back to the menu button when the story closes
    }
    v.openGift('', a);
  });
  function fromHash() {
    var m = /^#gifts(?:-([a-z0-9-]+))?$/i.exec(location.hash || '');
    if (!m) return;
    var v = giftViewer();
    if (!v) return;
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) { /* ignore */ }
    v.openGift((m[1] || '').toLowerCase());
  }
  window.addEventListener('hashchange', fromHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromHash); else fromHash();
  window.hnStories = {
    play: function (list, from) {
      var root = document.querySelector('[data-hn-st]');
      if (!root) return false;
      if (!root.hnStory) init();
      return !!(root.hnStory && root.hnStory.playList(list, from));
    }
  };
  document.addEventListener('shopify:section:load', init); // theme editor
})();
